<template>
  <div class="picCarousel">
    <!--<img v-if="currentPicIndex==0" src="../assets/images/Desert.jpg" />
    <img v-else-if="currentPicIndex==1" src="../assets/images/Jellyfish.jpg" />
    <img v-else-if="currentPicIndex==2" src="../assets/images/Lighthouse.jpg" />-->
    <img :src="picList[currentPicIndex]" />
    <div class="opt">
      <!--<button class="picbuttonbefore el-icon-arrow-left" @click="changeCurrentPic(prevPicIndex)"></button>-->
      <button class="picbutton" v-bind:class="{picbuttoncurrent:currentPicIndex==0}" @click="changeCurrentPic(0)"></button>&nbsp;&nbsp;&nbsp;
      <button class="picbutton" v-bind:class="{picbuttoncurrent:currentPicIndex==1}" @click="changeCurrentPic(1)"></button>&nbsp;&nbsp;&nbsp;
      <button class="picbutton" v-bind:class="{picbuttoncurrent:currentPicIndex==2}" @click="changeCurrentPic(2)"></button>
      <!--<button class="picbuttonafter el-icon-arrow-right" @click="changeCurrentPic(nextPicIndex)"></button>-->
    </div>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      currentPicIndex:0,
      timer:null,
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.timer = setInterval(() => {
        this.changeCurrentPic(this.nextPicIndex)
        console.log(this.currentPicIndex)
      }, 5000)
    })
  },
  props:['picList'],
  computed: {
    //上一张
    prevPicIndex() {
      if(this.currentPicIndex == 0) {
        return this.picList.length - 1;
      }else{
        return this.currentPicIndex - 1;
      }
    },
    //下一张
    nextPicIndex() {
      if(this.currentPicIndex == this.picList.length - 1) {
        return 0;
      }else {
        return this.currentPicIndex + 1;
      }
    }
  },
  methods: {
    changeCurrentPic(index){
      this.currentPicIndex = index;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.picCarousel{
  position: relative;
  width: 100%;
   height: 560px;
  /* 
   margin-left: 63px;*/
  display:table-cell;
  vertical-align:middle;
  overflow: hidden;
}
.picCarousel img{
  width: 100%;
  /* width: 641px;
   height: 560px;*/
   object-fit: cover;
   max-width: 100%;
   max-height: 100%;
}
.picCarousel .opt{
  margin-top: -50px;
  height: 50px;
  line-height: 40px;
  font-size:20px;
}
.picCarousel .opt:hover{
  background:rgba(235,238,245,.3);
}
.picCarousel .picbutton{
  /*position: absolute;
  top: 20px;*/
  background:#C0C4CC;
  width:10px;
  height:10px;
  border-radius:10px;
  border:1px solid #C0C4CC;
}
.picCarousel .picbutton:hover{
  background:#909399;
  border:1px solid #909399;
}
.picCarousel .picbuttonbefore{
  color:#C0C4CC;
  margin-right:12.75px;
}
.picCarousel .picbuttonbefore:hover{
  color:#909399;
}
.picCarousel .picbuttonafter{
  color:#C0C4CC;
  margin-left:30px;
}
.picCarousel .picbuttonafter:hover{
  color:#909399;
}
.picCarousel .picbuttoncurrent{
  background:#606266;
  border:1px solid #606266;
}
</style>




// WEBPACK FOOTER //
// src/components/PicCarousel.vue